import _defaults from 'lodash/defaults'

export default {
  getters: {
    PersonalInformationForms: (state, getters) => {
      return _defaults(
        getters.currentTripDashboardId
          ? getters.Trips[getters.currentTripDashboardId].personal_information_forms
          : {},
        {
          'section-heading': 'Personal Information Forms',
          'section-subheading': '<p>Here you will find your personal information forms.</p>'
        }
      )
    }
  }
}
